export default __webpack_public_path__ + "static/media/LOGO-GM-White.49e9f43e.svg";